import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analysis-page" }
const _hoisted_2 = { class: "button-grid" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AnalysisPage',
  setup(__props) {

// Script logic can go here later

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", null, "成绩分析", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/analysis/student",
        class: "analysis-button"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "学生分析", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/student-challenge",
        class: "analysis-button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", null, "学生挑战", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/rank-details",
        class: "analysis-button"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", null, "名次详情", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/gradeanalysis/mistakes",
        class: "analysis-button"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", null, "错题合集", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})